import React from 'react';
import { useTheme } from '../contexts/ThemeContext';

const FilterSidebar = ({ 
  categories = [], 
  statuses = [], 
  selectedCategories = [], 
  selectedStatuses = [], 
  onCategoryChange, 
  onStatusChange,
  onClearFilters,
  title = "Filters"
}) => {
  const { isDarkMode } = useTheme();

  const sidebarStyle = {
    width: '250px',
    maxWidth: '100%',
    backgroundColor: isDarkMode ? '#1a1a1a' : '#f8f9fa',
    border: `1px solid ${isDarkMode ? '#333' : '#e9ecef'}`,
    borderRadius: '8px',
    padding: '1.5rem',
    marginRight: '1.5rem',
    marginBottom: '1.5rem',
    height: 'fit-content',
    position: 'sticky',
    top: '1rem',
    flexShrink: 0
  };

  const sectionStyle = {
    marginBottom: '2rem'
  };

  const sectionTitleStyle = {
    fontSize: '1.1rem',
    fontWeight: '600',
    marginBottom: '1rem',
    color: isDarkMode ? '#fff' : '#333',
    borderBottom: `1px solid ${isDarkMode ? '#333' : '#e9ecef'}`,
    paddingBottom: '0.5rem'
  };

  const filterItemStyle = {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '0.75rem',
    cursor: 'pointer',
    padding: '0.5rem',
    borderRadius: '4px',
    transition: 'background-color 0.2s ease'
  };

  const checkboxStyle = {
    marginRight: '0.75rem',
    width: '16px',
    height: '16px',
    accentColor: '#007bff'
  };

  const labelStyle = {
    color: isDarkMode ? '#e9ecef' : '#495057',
    fontSize: '0.9rem',
    fontWeight: '500',
    flex: 1
  };

  const countStyle = {
    color: isDarkMode ? '#6c757d' : '#6c757d',
    fontSize: '0.8rem',
    marginLeft: '0.5rem'
  };

  const clearButtonStyle = {
    width: '100%',
    padding: '0.5rem',
    backgroundColor: 'transparent',
    border: `1px solid ${isDarkMode ? '#495057' : '#6c757d'}`,
    borderRadius: '4px',
    color: isDarkMode ? '#6c757d' : '#6c757d',
    cursor: 'pointer',
    fontSize: '0.9rem',
    transition: 'all 0.2s ease'
  };

  const handleCategoryClick = (category) => {
    if (onCategoryChange) {
      onCategoryChange(category);
    }
  };

  const handleStatusClick = (status) => {
    if (onStatusChange) {
      onStatusChange(status);
    }
  };

  const hasActiveFilters = selectedCategories.length > 0 || selectedStatuses.length > 0;

  return (
    <div style={sidebarStyle}>
      <h3 style={sectionTitleStyle}>{title}</h3>
      
      {/* Categories Section */}
      {categories.length > 0 && (
        <div style={sectionStyle}>
          <h4 style={sectionTitleStyle}>Categories</h4>
          {categories.map((category) => (
            <div
              key={category.value}
              style={{
                ...filterItemStyle,
                backgroundColor: selectedCategories.includes(category.value) 
                  ? (isDarkMode ? '#2a2a2a' : '#e3f2fd') 
                  : 'transparent'
              }}
              onClick={() => handleCategoryClick(category.value)}
              onMouseEnter={(e) => {
                if (!selectedCategories.includes(category.value)) {
                  e.target.style.backgroundColor = isDarkMode ? '#2a2a2a' : '#f8f9fa';
                }
              }}
              onMouseLeave={(e) => {
                if (!selectedCategories.includes(category.value)) {
                  e.target.style.backgroundColor = 'transparent';
                }
              }}
            >
              <input
                type="checkbox"
                checked={selectedCategories.includes(category.value)}
                onChange={() => {}} // Handled by parent div onClick
                style={checkboxStyle}
              />
              <span style={labelStyle}>{category.label}</span>
              {category.count !== undefined && (
                <span style={countStyle}>({category.count})</span>
              )}
            </div>
          ))}
        </div>
      )}

      {/* Status Section */}
      {statuses.length > 0 && (
        <div style={sectionStyle}>
          <h4 style={sectionTitleStyle}>Status</h4>
          {statuses.map((status) => (
            <div
              key={status.value}
              style={{
                ...filterItemStyle,
                backgroundColor: selectedStatuses.includes(status.value) 
                  ? (isDarkMode ? '#2a2a2a' : '#e3f2fd') 
                  : 'transparent'
              }}
              onClick={() => handleStatusClick(status.value)}
              onMouseEnter={(e) => {
                if (!selectedStatuses.includes(status.value)) {
                  e.target.style.backgroundColor = isDarkMode ? '#2a2a2a' : '#f8f9fa';
                }
              }}
              onMouseLeave={(e) => {
                if (!selectedStatuses.includes(status.value)) {
                  e.target.style.backgroundColor = 'transparent';
                }
              }}
            >
              <input
                type="checkbox"
                checked={selectedStatuses.includes(status.value)}
                onChange={() => {}} // Handled by parent div onClick
                style={checkboxStyle}
              />
              <span style={labelStyle}>{status.label}</span>
              {status.count !== undefined && (
                <span style={countStyle}>({status.count})</span>
              )}
            </div>
          ))}
        </div>
      )}

      {/* Clear Filters Button */}
      {hasActiveFilters && onClearFilters && (
        <button
          style={clearButtonStyle}
          onClick={onClearFilters}
          onMouseEnter={(e) => {
            e.target.style.backgroundColor = isDarkMode ? '#2a2a2a' : '#f8f9fa';
            e.target.style.borderColor = isDarkMode ? '#007bff' : '#007bff';
            e.target.style.color = isDarkMode ? '#007bff' : '#007bff';
          }}
          onMouseLeave={(e) => {
            e.target.style.backgroundColor = 'transparent';
            e.target.style.borderColor = isDarkMode ? '#495057' : '#6c757d';
            e.target.style.color = isDarkMode ? '#6c757d' : '#6c757d';
          }}
        >
          Clear All Filters
        </button>
      )}
    </div>
  );
};

export default FilterSidebar;
